import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../ui/badge';
import { Sparkles, TrendingUp, AlertTriangle } from 'lucide-react';

const isNewProduct = (createdAt) => {
  const daysSinceCreated = (Date.now() - new Date(createdAt)) / (1000 * 60 * 60 * 24);
  return daysSinceCreated <= 30;
};

const isBestSeller = (reviewsCount) => {
  return reviewsCount && reviewsCount >= 500;
};

const isLowStock = (stock) => {
  return stock > 0 && stock <= 20;
};

export const ProductBadges = ({ product, className = '' }) => {
  const { t } = useTranslation();
  const badges = [];

  if (isNewProduct(product.created_at)) {
    badges.push({
      label: t('product.new'),
      variant: 'default',
      icon: Sparkles,
      className: 'bg-accent text-accent-foreground'
    });
  }

  if (isBestSeller(product.reviews_count)) {
    badges.push({
      label: t('product.bestSeller'),
      variant: 'default',
      icon: TrendingUp,
      className: 'bg-success text-success-foreground'
    });
  }

  if (isLowStock(product.stock_quantity)) {
    badges.push({
      label: t('product.onlyLeft', { count: product.stock_quantity }),
      variant: 'warning',
      icon: AlertTriangle,
      className: 'bg-warning text-warning-foreground'
    });
  }

  if (badges.length === 0) return null;

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {badges.map((badge, index) => {
        const Icon = badge.icon;
        return (
          <Badge
            key={index}
            variant={badge.variant}
            className={`flex items-center gap-1 w-fit ${badge.className}`}
          >
            <Icon className="w-3 h-3" />
            {badge.label}
          </Badge>
        );
      })}
    </div>
  );
};

export { isNewProduct, isBestSeller, isLowStock };